import type { QNotifyCreateOptions } from 'quasar'
import { Notify, Dialog } from 'quasar'
import { i18n } from '../boot/i18n'

export const success = (i18nMessage?: string, dismissable = false) => {
  const message = i18nMessage ? i18n.global.t(i18nMessage) : 'Success'
  const notificationOptions: QNotifyCreateOptions = {
    message,
    position: 'top',
    color: 'positive',
  }

  if (dismissable) {
    notificationOptions.timeout = 0
    notificationOptions.actions = [{ label: 'Dismiss', color: 'white' }]
    notificationOptions.html = true
  }

  Notify.create(notificationOptions)
}

type FluentError = {
  message: string
  errors: { errorCode: string; errorMessage: string; propertyName: string }[]
}
export const fail = (i18nMessage?: string | FluentError, timeout = 10000) => {
  // Use the message directly as fallback for now
  let displayMessage =
    typeof i18nMessage === 'string' ? i18n.global.t(i18nMessage) : 'Error'
  if (typeof i18nMessage === 'object') {
    if ('message' in i18nMessage) {
      displayMessage = i18n.global.t(i18nMessage.message)
    }
    if ('errors' in i18nMessage && i18nMessage.errors.length > 0) {
      displayMessage = i18nMessage.errors
        .map((e) => i18n.global.t(e.errorMessage))
        .join('<br/>')
    }
  }
  Notify.create({
    message: displayMessage,
    timeout,
    color: 'negative',
    icon: 'info',
    html: true,
    position: 'top',
  })
}

export const warn = (i18nMessage?: string, timeout = 10000) => {
  const message = i18nMessage ? i18n.global.t(i18nMessage) : 'Warning'
  Notify.create({
    message,
    timeout,
    color: 'warning',
    icon: 'warning',
    html: true,
    position: 'top',
  })
}

export interface IConfirmOptions {
  title?: string
  message?: string
  cancel?: boolean
  persistent?: boolean
  okHandler?: () => void
  cancelHandler?: () => void
}

export const confirm = (options: IConfirmOptions) => {
  const {
    title,
    message,
    okHandler,
    cancelHandler,
    cancel = true,
    persistent = false,
  } = options
  Dialog.create({
    title: title || 'Alert',
    message: message || '',
    cancel: cancel,
    persistent,
    html: true,
  })
    .onOk(() => {
      okHandler?.()
    })
    .onCancel(() => {
      cancelHandler?.()
    })
}

export const notifySaved = (i18nMessage?: string) => {
  const message =
    i18nMessage ?? 'notificationSettings.changesSavedAutomatically'
  Notify.create({
    message: i18n.global.t(message),
    icon: 'check_circle',
    position: 'bottom',
    timeout: 2000,
    color: 'white',
    textColor: 'green-8',
    classes:
      'cf-center-config-notify tw-border tw-border-green-200 tw-rounded-lg tw-shadow-lg tw-font-medium tw-mx-none',
    iconColor: 'positive',
    iconSize: 'xs',
  })
}
